import arrowRight from '@/assets/svg/arrow-right.svg'
import { LangText } from '@/components'
import { preFixImgUrl } from '@/utils'
import {
  openSagawaDeliveryBooking,
  SAGAWA_PRECAUTIONS_AND_FAQ_URL,
} from '../constants'

const BANNER_BACKGROUND =
  'https://static.xyb2b.com/images/4d0fd398d00d3e23e3a16eba51e28f0d.png'

const FAQ_ICON = 'c9d2a161abe51e1eaf51cd4b1bbd8186.png'

const BottomBanner = () => (
  <section className="group relative h-[480px] w-full overflow-hidden">
    <div
      className="absolute inset-0 bg-cover bg-center bg-no-repeat transition-transform duration-700 ease-out group-hover:scale-105"
      style={{ backgroundImage: `url(${preFixImgUrl(BANNER_BACKGROUND)})` }}
      aria-hidden
    />

    <div className="relative z-[1] mx-auto flex h-full w-[1200px] flex-col items-center pt-[72px] text-white">
      <LangText
        lngKey="sagawa.cta.title"
        className="text-[36px] font-bold leading-[50px]"
      />
      <LangText
        lngKey="sagawa.cta.description"
        className="mt-[16px] text-[28px] leading-[40px]"
      />

      <button
        type="button"
        onClick={openSagawaDeliveryBooking}
        className="mt-[32px] h-[48px] cursor-pointer rounded-full bg-white px-[30px] text-[20px] font-medium text-primary transition-[transform,box-shadow] duration-300 hover:scale-105 hover:shadow-[0_10px_24px_rgba(0,0,0,0.16)]"
      >
        <LangText lngKey="sagawa.cta.bookNow" />
      </button>

      <nav className="mt-[76px] h-[80px] w-[1120px] overflow-hidden rounded-full border border-white/40 bg-white/15 backdrop-blur-[8px]">
        <a
          href={SAGAWA_PRECAUTIONS_AND_FAQ_URL}
          target="_blank"
          rel="noopener noreferrer"
          className="group/link flex h-full w-full items-center justify-center gap-[12px] rounded-full text-[20px] transition-colors duration-300 hover:bg-white/15"
        >
          <img
            src={preFixImgUrl(FAQ_ICON)}
            alt=""
            className="h-[40px] w-[40px] object-contain transition-transform duration-300 group-hover/link:scale-110"
            aria-hidden
          />
          <LangText lngKey="sagawa.cta.links.precautionsAndFaq" />
          <img
            src={arrowRight}
            alt=""
            className="h-[14px] w-[14px] object-contain transition-transform duration-300 group-hover/link:translate-x-[2px]"
            aria-hidden
          />
        </a>
      </nav>
    </div>
  </section>
)

export default BottomBanner
